import { PageBreadcrumbsWithLinks } from '@/components'
import React, { lazy, useEffect, useState } from 'react'
import { administratorsBreadcrumb } from '@/constants/adminPage'
import { MenuLinks } from '@/constants/menu'
import { useNavigate } from 'react-router-dom'
import { PlatformLookUpCodeTypes } from '@/helpers/api/WebApiClient'
import withSuspense from '@/helpers/suspense.helper'
import { useTranslation } from 'react-i18next'
import { PageBody, PageTitle, PageWrapper } from '@/components/PageWrapper'

const ViewPlatformLookUpCodes = withSuspense(lazy(() => import('./Components/ViewPlatformLookUpCodes')))

type ModalState = {
	redirectToManageLookUpValueScreen: boolean
	idForEdit: number
	platformLookUpCodeType?: PlatformLookUpCodeTypes
}

const ManagePlatformLookUps: React.FC = () => {
	const { t } = useTranslation()
	const [modalState, setModalState] = useState<ModalState>({
		redirectToManageLookUpValueScreen: false,
		idForEdit: 0,
	})

	const navigate = useNavigate()

	const onActionClick = async (id: number, action: string, lookUpCodeType: PlatformLookUpCodeTypes) => {
		if (action === 'ViewValues') {
			setModalState((prev) => ({ ...prev, idForEdit: id, redirectToManageLookUpValueScreen: true, platformLookUpCodeType: lookUpCodeType }))
		}
	}
	useEffect(() => {
		if (modalState.redirectToManageLookUpValueScreen) {
			navigate(MenuLinks.ManagePlatformLookUpValues.replace(':id', String(modalState.platformLookUpCodeType)).replace(':lookupCodeId', String(modalState.idForEdit)))
		}
	}, [modalState])

	return (
		<>
			<PageBreadcrumbsWithLinks
				title={t('Manage.Nexus.Lookups_Heading', 'Platform Lookups')}
				subNames={administratorsBreadcrumb(t('Manage.Nexus.Lookups_Breadcrumb', 'Platform Lookups'))}
			/>

			<PageWrapper>
				<PageTitle title={t('Manage.Nexus.Lookups_Heading', 'Platform Lookups')} />
				<PageBody>
					<ViewPlatformLookUpCodes onActionClick={onActionClick} />
				</PageBody>
			</PageWrapper>
		</>
	)
}

export default ManagePlatformLookUps
